const options = {
  5: "bg-pink-500/5",
  10: "bg-pink-500/10",
  25: "bg-pink-500/25",
  50: "bg-pink-500/50",
  75: "bg-pink-500/75",
  90: "bg-pink-500/90",
  100: "bg-pink-500",
};

const from = {
  5: "from-pink-500/5",
  10: "from-pink-500/10",
  25: "from-pink-500/25",
  50: "from-pink-500/50",
  75: "from-pink-500/75",
  90: "from-pink-500/90",
  100: "from-pink-500",
};

export default function getBackgroundPink500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
